module.exports = [{"name":"FsdMoc","image_url":"images/partners/fsdmoc.png","url":"https://fsdmoc.com"},{"name":"M-Pesa","image_url":"images/partners/mpesa.png","url":"https://mpesa.co.mz"},{"name":"SabeTudo","image_url":"images/partners/sabetudo.png","url":"https://sabetudo.co.mz"},{"name":"eKUSchool","image_url":"images/partners/ekuschool.png","url":"https://ekuschool.ekutivasolutions.com"}]


//////////////////
// WEBPACK FOOTER
// ./src/database/partners.json
// module id = csKB
// module chunks = 0